import { Group, Button } from '@mantine/core';

interface SaveCardProps {
  handleSave: () => any;
  handleCancel: () => void;
}

export const SaveCard: React.FC<SaveCardProps> = props => {
  return (
    <div>
      <Group justify="flex-end" mt="xl">
        <Button variant="outline" onClick={props.handleCancel}>
          Zrušit
        </Button>
        <Button variant="filled" onClick={props.handleSave}>
          Uložit
        </Button>
      </Group>
    </div>
  );
};
